import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { UserData } from '../models/userdata';

@Injectable({
    providedIn: 'root'
})
export class SessionService {
    private userDataSubject: BehaviorSubject<UserData> = new BehaviorSubject<UserData>({
        isBox5G: false,
        isRed: false,
        isMobile: false,
        isHome: false,
        isBox4G: false,
        isCC: false,
        isDistrib: false,
        isSrr: false,
        isTiers: false,
        isInternetResilie: false,
        isMobileResilie: false,
        isMobileAbonneRed: false,
        isMobileAbonneSfr: false,
        pdv: '0000000'
    });

    private userDataLoadedSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    constructor() {
    }

    getUserData(): Observable<UserData> {
        return this.userDataSubject.asObservable();
    }

    isUserDataLoaded(): Observable<boolean> {
        return this.userDataLoadedSubject.asObservable();
    }

    setUserData(userdata: UserData) {
        this.userDataSubject.next(userdata);
        this.setLoaded(true);
    }
    setLoaded(loaded: boolean) {
        this.userDataLoadedSubject.next(loaded);
    }
}
